import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { AccountSelectors, ModalsService, ModulesSelectors } from '@serviceos-ng/core';
import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AccountDeletionModalComponent } from '../account-deletion-modal/account-deletion-modal.component';

@Component({
    selector: 'serviceos-web-account-deletion-form',
    templateUrl: './account-deletion-form.component.html',
    styleUrls: ['./account-deletion-form.component.scss'],
})
export class AccountDeletionFormComponent implements OnInit, OnDestroy {
    @Select(AccountSelectors.deleteAccountRequested)
    public deleteAccountRequested!: Observable<boolean>;

    @Select(
        ModulesSelectors.getComponentFromModule(
            'account',
            'account_settings_screen.account_management'
        )
    )
    accountManagement$!: Observable<any>;

    public subscriptions: Subscription[] = [];

    constructor(private _modalsService: ModalsService) {}

    ngOnInit(): void {
        this.subscriptions.push(
            this.deleteAccountRequested
                .pipe(
                    tap((deleteAccountRequested) => {
                        //
                    })
                )
                .subscribe()
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.map((el) => el.unsubscribe());
    }

    public onDeleteAccountClick(): void {
        this._modalsService.open(AccountDeletionModalComponent, {
            type: 'sidebar',
        });
    }
}
